import { Component, computed, input, inject } from '@angular/core';
import { LoaderService } from '../../services/loading/loader.service';

/**
 * Component to show a loading spinner overlay.
 * * Behavior:
 * 1. **Manual Mode**: If [isVisible] is provided (true/false), the spinner
 * is constrained to its nearest `position: relative` parent.
 * 2. **Global Mode**: If [isVisible] is null (default), the component
 * listens to the `LoaderService` and displays a full-screen overlay.
 * * @example
 * * <app-spinner></app-spinner>
 * * * <div style="position: relative;">
 * <app-spinner [isVisible]="isLoading"></app-spinner>
 * </div>
 */
@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: true,
})
export class SpinnerComponent {
  loader = inject(LoaderService);

  isVisible = input<boolean | null>(null);

  showSpinner = computed(() => {
    const manualValue = this.isVisible();
    return manualValue !== null ? manualValue : this.loader.isLoading();
  });
}
